import base from './url_base';

const URL = {
  INIT_CSRF: '/sanctum/csrf-cookie',
  LOGIN: base.API + '/spa-auth/login',
  LOGOUT: base.API + '/spa-auth/logout',
  FORGET_PASSWORD: base.API + '/spa-auth/forget-password',
  RESET_PASSWORD: base.API + '/spa-auth/reset-password',
  MY_PROFILE: base.API + '/profile',
  PROFILE_REQUIREMENTS: base.API + '/profile/requirements',
};

export default URL;
